import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const EXCLUDED = [
  /^\/$/,                    // "/"
  /^\/turbo-form$/,          // exact "/turbo-form"
  /^\/dashboard(?:\/|$)/,    // "/dashboard" and any subpath
  /^\/auth(?:\/|$)/,         // "/auth" and any subpath
]

const isExcluded = (pathname) => EXCLUDED.some((rx) => rx.test(pathname));

const normalizePath = (p) => (p !== "/" && p.endsWith("/") ? p.slice(0, -1) : p);


export default function RouteChangeTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const url = window.location.href
    const path = normalizePath(pathname)

    if (window.clarity) {
      if (!isExcluded(path) && !url.includes('localhost')) {
        window.clarity("event", "page_view", { path: pathname, search });
        console.log('active')
      }
    }
    
    console.log(window.clarity)
  }, [pathname, search]);

  return null; // no UI
}
